import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// ============================================
// Loading Spinner Component
// ============================================

/**
 * LoadingSpinner - Toont een draaiende spinner voor loading states.
 * 
 * Gebruik:
 * ```tsx
 * <LoadingSpinner size="md" />
 * ```
 */

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-3',
  xl: 'w-12 h-12 border-4',
};

const labelText = {
  sm: 'Laden...',
  md: 'Laden...',
  lg: 'Een moment geduld...',
  xl: 'Bezig met laden...',
};

export const LoadingSpinner = ({
  size = 'md',
  className,
  label,
}: LoadingSpinnerProps) => {
  return (
    <div className="flex items-center justify-center gap-3" role="status">
      <div
        className={twMerge(
          clsx(
            'animate-spin rounded-full border-primary-500 border-t-transparent',
            sizeClasses[size],
            className
          )
        )}
        aria-hidden="true"
      />
      {label && (
        <span className="text-sm text-gray-600 sr-only">
          {label}
        </span>
      )}
      <span className="sr-only">{label || labelText[size]}</span>
    </div>
  );
};

export default LoadingSpinner;
